export default "__VITE_ASSET__a26f1b14__"